import OrbitApiV1 from 'api/orbitV1'
import { AxiosPromise } from 'axios'
import {
  CreateUserPlanResponse,
  GetActiveUserPlansType,
  GetAllFaberUsers,
  GetAllOtpackUserPlansType,
  GetOtpackHistoryType,
  GetPlansDetailsType,
  GetSubscriptionUserPlansType
} from 'types/api/faber/oneTimePack.type'

import FaberApi from '.'

class OneTimePackApi {
  static getAllFaberUsers(body: {
    searchCriteria: string
    searchValue: string
    faberToken: string
    limit: number
    planStatus: string
    offset: number
  }): AxiosPromise<GetAllFaberUsers> {
    let searchField = ''
    switch (body.searchCriteria) {
      case 'Email':
        searchField = 'email'
        break
      case 'MSISDN':
        searchField = 'msisdn'
        break
      case 'ICCID':
        searchField = 'iccid'
        break
      case 'Customer ID':
        searchField = 'userId'
        break
    }

    const searchValue = body.searchValue

    const requestBody = {
      [searchField]: searchValue,
      faberToken: body.faberToken,
      limit: body.limit,
      offset: body.offset,
      status: body.planStatus
    }

    return OrbitApiV1.httpPost(
      `/faber/user/search?&limit=${body.limit}&offset=${body.offset}&sort=desc`,
      {
        Authorization: `Bearer ${body.faberToken}`
      },
      requestBody
    )
  }

  static getAllInactiveOtpackUserPlans(
    userId: string,
    faberToken: string
  ): AxiosPromise<GetAllOtpackUserPlansType> {
    return FaberApi.httpGet(
      `/sim/ops/plan/${userId}?planStatuses=INACTIVE`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      true
    )
  }

  static getAlTerminatedOtpackUserPlans(
    userId: string,
    faberToken: string
  ): AxiosPromise<GetAllOtpackUserPlansType> {
    return FaberApi.httpGet(
      `/sim/ops/plan/${userId}?planStatuses=TERMINATED`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      true
    )
  }

  static getActiveOtpUserPacks(
    userId: string,
    faberToken: string
  ): AxiosPromise<GetActiveUserPlansType> {
    return FaberApi.httpGet(
      `/sim/ops/plan/active/${userId}`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      true
    )
  }

  static getSubscriptionUserPacks(
    userId: string,
    faberToken: string
  ): AxiosPromise<GetSubscriptionUserPlansType> {
    return FaberApi.httpGet(
      `/subscriptions?userID=${userId}`,
      { Authorization: `Bearer ${faberToken}` },
      true
    )
  }

  static getOtpackPlanHistory(
    userPlanId: string,
    faberToken: string
  ): AxiosPromise<GetOtpackHistoryType> {
    return FaberApi.httpGet(
      `/sim/ops/planhistory/${userPlanId}`,
      { Authorization: `Bearer ${faberToken}` },
      true
    )
  }

  static getAllUserPlans(
    faberToken: string
  ): AxiosPromise<GetPlansDetailsType> {
    return FaberApi.httpGet(
      '/sim/ops/plan/count',
      {
        Authorization: `Bearer ${faberToken}`
      },
      true
    )
  }

  static createUserPlan(body: {
    userId: string
    catalogId: string
    planStatus: string
    paymentIntent: string
    faberToken: string
  }): AxiosPromise<CreateUserPlanResponse> {
    return FaberApi.httpPost(
      `/sim/ops/plan/${body.userId}`,
      {
        Authorization: `Bearer ${body.faberToken}`
      },
      body
    )
  }
}
export default OneTimePackApi
